import * as Color from "../Color";
import { IconColor } from "./IconColor";

/**
 * Gets a color from an icon color.
 * @param iconColor The icon color.
 * @returns The color representiing the icon color.
 */
export function getColorFromIconColor(iconColor: IconColor): Color.RgbColor {
  switch (iconColor) {
    default:
    case "black":
      return Color.Black;
    case "white":
      return Color.White;
    case "darkblue":
      return Color.DarkBlue[500];
    case "darkgreen":
      return Color.Green[800];
    case "darkgrey":
      return Color.LightGrey[700];
    case "green":
      return Color.Green[500];
    case "orange":
      return Color.Orange[500];
    case "lightgrey":
      return Color.LightGrey[300];
    case "red":
      return Color.Red[500];
    case "turquoise":
      return Color.Turqoise[500];
    case "body":
      return Color.LightGrey[700];
    case "purple":
      return Color.Purple[500];
  }
}
